export default __webpack_public_path__ + "static/media/ic_guernsey.8a42d6a7.svg";